<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="成交客户分析" name="deal" v-if="Acs('/customer-count/deal-conv-count')"></el-tab-pane>
                <el-tab-pane label="试用转化分析" name="try" v-if="Acs('/guanbi-count/try-conv-count')"></el-tab-pane>
            </el-tabs>
            <Deal v-if="activeName == 'deal' && Acs('/customer-count/deal-conv-count')" :activeName="activeName"></Deal>
            <Try v-else-if="activeName == 'try' && Acs('/guanbi-count/try-conv-count')" :activeName="activeName"></Try>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
import Deal from "~/views/count/customer/deal.vue";
import Try from "~/views/count/customer/try.vue";
export default {
    name: "customeranalysis",

    components: {
        Deal,
        Try
    },

    props: {
        
    },

    data() {
        return {
            activeName: 'deal',
        };
    },

    mounted() {

    },

    created() {
        if(!this.Acs('/customer-count/deal-conv-count')){
            this.activeName = 'try';
        }
    },

    methods: {
        handleClick(tab, event) {

        },

        handleFinishClick(tab, event){

        },

        handleGoalClick(tab, event){

        },
    },
};
</script>


// WEBPACK FOOTER //
// src/views/count/customeranalysis.vue